<template>
  <div>
    <b-table
      :id="id"
      ref="reportListTableRef"
      :bordered="true"
      :items="listReport"
      :fields="reportFields"
      class="table-striped mt-1"
      :primary-key="'id'"
      role="grid"
      aria-describedby="user-list-page-info"
    >
      <template v-slot:cell(stt)="data">
        <span>{{data.item.stt}}</span>
      </template>
      <template v-slot:cell(title)="data">
        <div class="flex align-items-center">
          <span v-html="data.item.space"/>
          <i v-show="data.item.children.length > 0 && data.item && !data.item.toggle" @click="fetchMember(data.index)" class="las la-caret-square-right"/>
          <i v-show="data.item.children.length > 0 && data.item && data.item.toggle" @click="recursiveCloseSquare(data.item.custom_id, false)" class="las la-caret-square-down"/>
          <span class="ml-2">{{ data.item.title }}</span>
        </div>
      </template>
      <template v-slot:cell(vnd)="data">
        <span :style="applyNumberStyle(data.item.total_vnd)">{{data.item.total_vnd}}</span>
      </template>

      <template v-slot:cell(usd)="data">
        <span :style="applyNumberStyle(data.item.total_usd)">{{data.item.total_usd}}</span>
      </template>

      <template v-slot:custom-foot>
        <tr>
          <td></td>
          <td align="right">TỔNG</td>
          <td align="right" :style="applyNumberStyle(detailReport.summary_total_vnd)">{{applyNumberFormat(detailReport.summary_total_vnd, 'th')}}</td>
          <td align="right" :style="applyNumberStyle(detailReport.summary_total_usd)">{{applyNumberFormat(detailReport.summary_total_usd, 'en')}}</td>
        </tr>
      </template>
    </b-table>
  </div>
</template>

<script>
import { findash } from '../../../../config/pluginInit'
import _ from 'lodash'
import { applyNumberStyle, formatNumber, formatNumberByLocale } from '@/utils'
import { mapGetters } from 'vuex'

function isEmptyData (ele) {
  return (ele.total_vnd === '0' && ele.total_usd === '0') || (ele.total_vnd === 0 && ele.total_usd === 0)
}

export default {
  name: 'KeToan',
  async mounted () {
    findash.index()
  },
  created () {
  },
  props: [ 'id' ],
  data () {
    return {
      reportFields: [
        {
          key: 'stt',
          label: '#',
          class: 'text-center'
        },
        {
          key: 'title',
          label: 'THÀNH VIÊN',
          class: 'text-left'
        },
        {
          key: 'vnd',
          label: 'VND',
          class: 'text-right'
        },
        {
          key: 'usd',
          label: 'USD',
          class: 'text-right'
        }
      ],
      listReport: [],
      stt: 1,
      custom_id: 0,
      parseDataArr: null
    }
  },
  computed: {
    ...mapGetters({
      'detailReport': 'Report/detailReportState'
    })
  },
  watch: {
    detailReport: function (newVal, oldVal) {
      if (newVal !== oldVal && this.detailReport.detail_report) {
        this.parseData()
      }
    }
  },
  methods: {
    skeletorData (data, rootLevel) {
      _.map(data, (e) => {
        let children = e.children ? e.children : []
        let _stt = ''
        let _showCheckbox = false

        if (rootLevel) {
          _stt = this.stt++
          _showCheckbox = true
        }

        return _.extend(e, { custom_id: this.custom_id++, toggle: false, space: '', level: 1, children: children, stt: _stt, showCheckbox: _showCheckbox })
      })

      return data
    },
    skeletorDataParent (data, parentId, parentLevel) {
      _.map(data, (e) => {
        let createSpace = '&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp&nbsp'.repeat(parentLevel)
        return _.extend(e, { parentId: parentId, space: createSpace, level: parentLevel + 1 })
      })

      return data
    },
    async fetchMember (index) {
      let childMembers = this.skeletorData(this.listReport[index].children, false)
      //
      let that = this
      let currentIndex = index + 1 // after the current index
      let currentLevel = this.listReport[index].level

      // current use index instead of id
      this.skeletorDataParent(childMembers, this.listReport[index].custom_id, currentLevel)

      _.each(childMembers, (e) => {
        // must use shadow copy splice if want to change data
        that.listReport.splice(currentIndex, 0, e) // insert into array at position
        currentIndex++
      })

      this.listReport[index].toggle = true
    },
    recursiveCloseSquare (id, isChild) {
      let that = this
      let childrenClose = _.filter(this.listReport, (e) => {
        return e.parentId === id
      })
      _.each(childrenClose, (e) => {
        that.recursiveCloseSquare(e.custom_id, true)
      })

      let index = _.findIndex(this.listReport, (e) => e.custom_id === id)

      this.listReport[index].toggle = false

      // only use with shallow copy method like splice only
      if (isChild) { this.listReport.splice(index, 1) }
    },
    applyNumberStyle (number) {
      return applyNumberStyle(number)
    },
    applyNumberFormat (number, locale) {
      return formatNumberByLocale(number, locale)
    },
    parseData () {
      let parseDataReturn = null

      parseDataReturn = _.compact(_.map(this.detailReport.detail_report.details, (level0) => {
        if (isEmptyData(level0)) return
        return {
          'id': level0.id,
          'title': level0.name,
          'total_vnd': formatNumber(level0.total_vnd),
          'total_usd': formatNumber(level0.total_usd),
          'children': _.compact(_.map(level0.summary, (level1, category) => {
            if (level1.datas === undefined || level1.datas.length === 0 || isEmptyData(level1)) return
            return {
              'title': category.toUpperCase(),
              'total_vnd': formatNumber(level1.total_vnd),
              'total_usd': formatNumber(level1.total_usd),
              'children': _.compact(_.map(level1.datas, (level2) => {
                if (level2.datas === undefined || level2.datas.length === 0 || isEmptyData(level2)) return
                return {
                  'title': level2.username,
                  'total_vnd': formatNumber(level2.total_vnd),
                  'total_usd': formatNumber(level2.total_usd),
                  'children': _.compact(_.map(level2.datas, (level3, game) => {
                    if (level3.datas === undefined || level3.datas.length === 0 || isEmptyData(level3)) return
                    return {
                      'title': game.toUpperCase(),
                      'total_vnd': formatNumber(level3.total_vnd),
                      'total_usd': formatNumber(level3.total_usd),
                      'children': []
                    }
                  }))
                }
              }))
            }
          }))
        }
      }))

      this.listReport = this.skeletorData(parseDataReturn, true)

      // reset
      this.stt = 1
    }
  }
}
</script>
